import BMapsPage from '../src/ui/BMapsPage';

export default BMapsPage;
